import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { FORMATS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import { LABELS, WARNINGS, TITLES, SUCCESS, ERRORS, SUB_TITLES } from "common/lables";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";

const Team = (props: any) => {
  const { setDashMenu } = props;

  const userRef: any = useRef(null);
  const superiorRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [users, setUsers] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getUsers();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getMktgTeam(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getMktgTeam:", error);
    }
  };

  const getUsers = () => {
    const args = { activeStatus: true };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.userName,
          };
        });
        setUsers(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "userName",
      name: LABELS.MARKETING_PERSON,
      width: "20%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "superiorName",
      name: LABELS.REPORTING_TO,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "startDate",
      name: LABELS.FROM_DATE,
      width: "10%",
      type: "date",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },

    {
      key: "cutoffTime",
      name: LABELS.CUT_OFF_TIME,
      width: "10%",
      type: "date",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "rankNo",
      name: LABELS.HIERARCHY_LEVEL,
      width: "10%",
      type: "number",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "territoryDetails",
      name: LABELS.TERRITORY_DETAILS,
      width: "10%",
      type: "number",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "customerTypesDetails",
      name: LABELS.CUSTOMER_TYPE_DETAILS,
      width: "10%",
      type: "number",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "5%",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },

    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageTeam = () => {
    const rankNo = (
      document.getElementById("rankNo") as HTMLInputElement
    ).value.trim();
    const userId = userRef.current.selectedValue.id;
    const superiorId = superiorRef.current.selectedValue.id;
    const startDate = (
      document.getElementById("startDate") as HTMLInputElement
    ).value.trim();
    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // const cutoffTime = (
    //   document.getElementById("cutoffTime") as HTMLInputElement
    // ).value.trim();
    // const customerTypesDetails = (
    //   document.getElementById("customerTypesDetails") as HTMLInputElement
    // ).value.trim();
    // const territoryDetails = (
    //   document.getElementById("territoryDetails") as HTMLInputElement
    // ).value.trim();

    // Validations
    let errors = [];
    if (!userId) {
      errors.push({
        id: "user",
        msg:
          "<span class='bold'>" +
          LABELS.MARKETING_PERSON +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!superiorId) {
      errors.push({
        id: "superior",
        msg:
          "<span class='bold'>" +
          LABELS.REPORTING_TO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!startDate) {
      errors.push({
        id: " startDate",
        msg:
          "<span class='bold'>" +
          LABELS.FROM +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!rankNo) {
      errors.push({
        id: "rankNo",
        msg:
          "<span class='bold'>" +
          LABELS.HIERARCHY_LEVEL +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      userId: userId,
      superiorId: superiorId,
      startDate: startDate,
      rankNo: rankNo,
      // customerTypesDetails: customerTypesDetails,
      // territoryDetails: territoryDetails,            //TODO NEED To DISCUSS
      // cutoffTime: cutoffTime,
      activeStatus: selectBtnValue,
    };

    setIsSubmit(true);
    MASTER_APIs.manageMktgTeam(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME} </li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TEAM}</li>
        </ul>
        <h4>{TITLES.TEAM}</h4>
        <p>{SUB_TITLES.TEAM}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TEAM}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.TEAM + ": " + selectedRow.userName
              : "Add New " + LABELS.TEAM
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.MARKETING_PERSON}
              {<span className="red">*</span>}
            </label>
            <AutoComplete
              list={users}
              childRef={userRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.userId,
                      label: selectedRow.userName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red ">
            <label>
              {LABELS.REPORTING_TO}
              {<span className="red">*</span>}
            </label>
            <AutoComplete
              list={users}
              childRef={superiorRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.superiorId,
                      label: selectedRow.superiorName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required">
            <TxtRow
              id={"startDate"}
              label={LABELS.FROM_DATE}
              defaultValue={
                selectedRow.startDate
                  ? DateFunctions.getFormatedDate(
                      selectedRow.startDate,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE_ONLY
                    )
                  : DateFunctions.getDate(
                      "today",
                      "from",
                      FORMATS.SQL_DATE_ONLY
                    )
              }
              type={"date"}
              disabled={isSubmit}
              required={true}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"rankNo"}
              type={"number"}
              required={true}
              label={LABELS.HIERARCHY_LEVEL}
              defaultValue={
                selectedRow.id
                  ? Number(selectedRow.rankNo).toString()
                  : selectedRow.rankNo
              }
              disabled={isSubmit}
            />
          </div>
          {/*           TODO 
          
          <div className="formGroup">
            <TxtRow
              id={"cutoffTime"}
              type={"time"}
              label={"Cut-Off Time"}
              defaultValue={selectedRow.id ? selectedRow.rankNo : ""}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"customerTypesDetails"}
              type={"text"}
              label={"Customer Types Details"}
              defaultValue={                                                              
                selectedRow.id ? selectedRow.customerTypesDetails : ""
              }
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup">
            <TxtRow
              id={"territoryDetails"}
              type={"text"}
              label={"Territory Details"}
              defaultValue={selectedRow.id ? selectedRow.territoryDetails : ""}
              disabled={isSubmit}
            />
          </div> */}
          <div className="formGroup">
            <label>{LABELS.ACTIVE_STATUS}</label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                bgColor={COLORS.SAVE_GREEN}
                loading={isSubmit}
                onClick={manageTeam}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Team);
